import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const INBOX_API = `${BACKEND_URL}/api`;

const inboxApi = axios.create({ baseURL: INBOX_API });

const TOKEN_KEY = "clariva_inbox_token";

export const inboxToken = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (t) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};

inboxApi.interceptors.request.use(cfg => {
  const t = inboxToken.get();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

inboxApi.interceptors.response.use(
  r => r,
  err => {
    if (err?.response?.status === 401) inboxToken.clear();
    return Promise.reject(err);
  },
);

export default inboxApi;
